import Layout from "../components/Layout";
import { DeliveryBlotter } from "../components/_Transactions/DeliveryBlotter";

const DeliveryBlotterPage = (props: any) => {
    return (
        <Layout>
            <DeliveryBlotter/>
        </Layout>
    )
}

export default DeliveryBlotterPage